import styles from './error.module.sass';
import cn from 'classnames';
import { Text } from '../Text';
import { FontIcon, FontIconName, FontIconColor } from '../FontIcon';
import React, { DetailedHTMLProps, HtmlHTMLAttributes } from 'react';

interface ErrorPair {
    title: string;
    text?: string;
}

export interface ErrorProps extends DetailedHTMLProps<HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    icon?: FontIconName | React.ReactElement;
    iconColor?: FontIconColor;
    image?: React.ReactElement;
    errorPairs?: ErrorPair[];
    children?: React.ReactNode;
    absolute?: boolean;
}

export const Error = ({ icon, iconColor, image, errorPairs, children, absolute, ...props }: ErrorProps) => {
    const renderIcon = () => {
        if (!icon) return null;

        if (typeof icon === 'string') {
            return <FontIcon name={icon} size="large" md="size60" color={iconColor} />;
        } else if (React.isValidElement(icon)) {
            return icon;
        }
    };
    return (
        <div>
            <div className={`${styles.error} ${absolute && styles.absolute}`} {...props}>
                <div className={styles.ico}>
                    {renderIcon()}
                    {image && image}
                </div>
                {errorPairs && (
                    <div className={styles.description}>
                        {errorPairs.map((pair, index) => (
                            <div key={index}>
                                <Text as="h3" variant="h3" margin="0">
                                    {pair.title}
                                </Text>
                                {pair.text && (
                                    <Text as="p" margin="0" color="gray">
                                        {pair.text}
                                    </Text>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};
